"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_components_1 = require("styled-components");

var scenario_node_view_styles_1 = require("../scenario-node-view/scenario-node-view.styles");

var image_scenario_node_styles_1 = require("./image-scenario-node.styles");

var image_option_view_component_1 = __importDefault(require("../image-option-view/image-option-view.component"));

var ImageScenarioNode = function ImageScenarioNode(_ref) {
  var node = _ref.node,
      _ref$scale = _ref.scale,
      scale = _ref$scale === void 0 ? 1 : _ref$scale;
  var options = node.options;
  return react_1.default.createElement(styled_components_1.ThemeProvider, {
    theme: scenario_node_view_styles_1.initNodeTheme(scale)
  }, react_1.default.createElement(image_scenario_node_styles_1.StyledImageNodeWrapperDiv, null, options.length > 0 ? react_1.default.createElement(image_scenario_node_styles_1.StyledOptionsUl, null, node.options.map(function (option, i) {
    return react_1.default.createElement(image_scenario_node_styles_1.StyledOptionLi, {
      key: i
    }, react_1.default.createElement(image_option_view_component_1.default, {
      imageName: option.imageName,
      imageUrl: option.imageUrl
    }));
  })) : react_1.default.createElement(image_scenario_node_styles_1.StyledEmptyMessageP, null, "\u9078\u629E\u80A2\u306A\u3057")));
};

exports.default = ImageScenarioNode;